const fail = (error) => ({ ok: false, error });
const findTagEnd = (html, from) => {
    let quote = null;
    for (let i = from; i < html.length; i++) {
        const c = html[i];
        if (quote) {
            if (c === quote)
                quote = null;
            continue;
        }
        if (c === '"' || c === "'") {
            quote = c;
            continue;
        }
        if (c === '>')
            return i;
    }
    return -1;
};
const bracesBalanced = (css) => {
    let depth = 0;
    for (let i = 0; i < css.length; i++) {
        const c = css[i];
        if (c === '{')
            depth++;
        else if (c === '}') {
            depth--;
            if (depth < 0)
                return false;
        }
    }
    return depth === 0;
};
const CSS_EXECUTION = [
    { re: /expression\s*\(/i, why: 'CSS expression() is not allowed' },
    { re: /javascript\s*:/i, why: 'javascript: URLs are not allowed in CSS' },
    { re: /behaviou?r\s*:/i, why: 'CSS behavior is not allowed' },
    { re: /-moz-binding/i, why: '-moz-binding is not allowed in CSS' },
    { re: /<\s*script/i, why: 'Script tags are not allowed inside CSS' },
];
const validateCssBlock = (css) => {
    if (!bracesBalanced(css)) {
        return fail('Invalid CSS: unclosed or extra braces');
    }
    for (const { re, why } of CSS_EXECUTION) {
        if (re.test(css)) {
            return fail(why);
        }
    }
    return { ok: true };
};
/** Validates custom Head/Body HTML so store SSR html-minifier will not crash. */
export const validateWebsiteInjectHtml = (input) => {
    if (input == null) {
        return { ok: true };
    }
    if (typeof input !== 'string') {
        return fail('HTML must be a string');
    }
    if (!input.trim()) {
        return { ok: true };
    }
    const html = input;
    let i = 0;
    while (i < html.length) {
        const lt = html.indexOf('<', i);
        if (lt === -1) {
            break;
        }
        if (html.startsWith('<!--', lt)) {
            const end = html.indexOf('-->', lt + 4);
            if (end === -1) {
                return fail('Unclosed HTML comment');
            }
            i = end + 3;
            continue;
        }
        if (html.startsWith('<!', lt)) {
            const end = html.indexOf('>', lt + 2);
            if (end === -1) {
                return fail('Unclosed HTML tag');
            }
            i = end + 1;
            continue;
        }
        const next = html[lt + 1];
        if (next && /\s/.test(next)) {
            if (/^<\s+\/?\s*[a-zA-Z]/.test(html.slice(lt))) {
                return fail('Invalid HTML tag: do not put a space after "<" (use <script> not < script>)');
            }
            i = lt + 1;
            continue;
        }
        if (next === '/') {
            const end = findTagEnd(html, lt + 2);
            if (end === -1) {
                return fail('Unclosed HTML tag');
            }
            i = end + 1;
            continue;
        }
        if (next === '?') {
            const end = html.indexOf('?>', lt);
            if (end === -1) {
                return fail('Unclosed HTML tag');
            }
            i = end + 2;
            continue;
        }
        if (!next || !/[a-zA-Z]/.test(next)) {
            i = lt + 1;
            continue;
        }
        const nameMatch = html.slice(lt + 1).match(/^[a-zA-Z][\w:-]*/);
        const name = (nameMatch ? nameMatch[0] : '').toLowerCase();
        const gt = findTagEnd(html, lt + 1);
        if (gt === -1) {
            return fail('Unclosed HTML tag');
        }
        const attrs = html.slice(lt + 1 + name.length, gt);
        if (name === 'script' || name === 'style') {
            const closeRe = new RegExp(`</\\s*${name}\\s*>`, 'i');
            const rest = html.slice(gt + 1);
            const closeMatch = closeRe.exec(rest);
            if (!closeMatch) {
                return fail(`Unclosed <${name}> tag`);
            }
            const body = rest.slice(0, closeMatch.index);
            if (name === 'style') {
                const cssResult = validateCssBlock(body);
                if (!cssResult.ok) {
                    return cssResult;
                }
            }
            if (name === 'script' && !/\bsrc\s*=/i.test(attrs)) {
                const js = body.trim();
                if (js) {
                    try {
                        // Parse only; do not execute.
                        new Function(js);
                    }
                    catch {
                        return fail('Invalid JavaScript in <script> tag. Check for missing braces or syntax errors.');
                    }
                }
            }
            i = gt + 1 + closeMatch.index + closeMatch[0].length;
            continue;
        }
        i = gt + 1;
    }
    return { ok: true };
};
//# sourceMappingURL=website-inject.js.map